export class ImportPlaning {
    dateRange: string;
    nameRange: string;
    hoursRange: string;
    commentRange: string;

    academicYearId: number;
    associationId: number;
    groupId: number;
}